import { setCookie } from '@/lib/functions/setCookie';
import type { OrderState } from '@/lib/types/orderState';

const COOKIE_LIFETIME_DAYS = 1;

export function getOrderStateCookieKey(): string {
  return `${process.env.NEXT_PUBLIC_SYLIUS_CHANNEL_CODE}_OrderState`;
}

/** Writes order state to the channel cookie immediately (not via useEffect). */
export function persistOrderState(state: OrderState): void {
  if (typeof document === 'undefined') {
    return;
  }

  try {
    setCookie(getOrderStateCookieKey(), JSON.stringify(state), COOKIE_LIFETIME_DAYS);
  } catch {
    // no-op
  }
}
